import React, { Component, useContext } from 'react'

export type UserData = {
  userId: string;
  accessToken: string;
  data:UserDataDetails;
}

export type UserDataDetails = {
	  aud: string;
	  email: string;
	  exp:number;
	  iat:number;
	  iss:string;
	  jti:string
	  name:string;
	  preffered_name:string
	  rol:string[];
	  sub:string;
}
type IAuthContextProviderProps = {
  children: React.ReactNode;
};

interface IAuthContext  {
  token: string | null;
  userIsAuthenticated() : boolean;
  updateToken(token: string | null): void;
  userLogout(): void;
  userLogin(user:UserData):void;
  getUser() : UserData | null;
};

const AuthContext = React.createContext<IAuthContext>({
    token: null,
    userIsAuthenticated:  function(): boolean {
        throw new Error('Function not implemented.');
    },
	updateToken: function(token: string | null): void {
        throw new Error('Function not implemented.');
    },
    userLogout: function(): void {
        throw new Error('Function not implemented.');
    },
    userLogin: function(user: UserData): void {
        throw new Error('Function not implemented.');
    },
    getUser: function(): UserData | null {
        throw new Error('Function not implemented.');
    }
});

export function AuthProvider({ children }: IAuthContextProviderProps) {
  const [token, setToken] = React.useState<string | null | undefined>(
    undefined
  );

  React.useEffect(() => {
    setToken(localStorage.getItem("petclinic.token") || null);
  }, []);

  function updateToken(newToken: string | null) {
    if (!newToken) {
      localStorage.removeItem("petclinic.token");
    } else {
      localStorage.setItem("petclinic.token", newToken);
    }

    setToken(newToken);
  }

  function getUser():UserData | null{
	  if (localStorage.getItem("user") === null) {
		  return null;
	  }
      return JSON.parse(localStorage.getItem('user') || '{}')
  }

  function userIsAuthenticated(): boolean{
    let userObj = localStorage.getItem('user')
    if (!userObj || typeof userObj === undefined) {
      return false
    }
    let user:UserData = JSON.parse(userObj)
    
    // if user has token expired, logout user
    if (user && Date.now() > user.data.exp * 1000) {
      userLogout()
      return false
    }
    return true
  }

  function userLogin(user: UserData) {
    localStorage.setItem('user', JSON.stringify(user))
  }

  function userLogout(){
    localStorage.removeItem('user')
  }

  return token === undefined ? null : (
    <AuthContext.Provider value={{ token, userIsAuthenticated,updateToken,userLogout,userLogin,getUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthContext

export function useAuth() {
  return useContext(AuthContext)
}


export function useAuthToken() {
  const { token, userIsAuthenticated,updateToken,userLogout,userLogin,getUser } = React.useContext(AuthContext);
  return [token, userIsAuthenticated,updateToken,userLogout,userLogin,getUser] as const;
}

